// @ts-nocheck
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type Props = {
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  titleClassName?: string;
  noCard?: boolean;
};

export const MobileSection = ({
  title,
  action,
  children,
  className,
  titleClassName,
  noCard = false,
}: Props) => {
  return (
    <section className={cn('mb-4', className)}>
      <div className="flex items-center justify-between px-4 mb-2">
        <h2
          className={cn(
            'text-[11px] font-semibold uppercase tracking-wider text-muted-foreground',
            titleClassName,
          )}
        >
          {title}
        </h2>
        {action && <div className="text-xs">{action}</div>}
      </div>
      {noCard ? (
        children
      ) : (
        <div className="mx-3 rounded-2xl border border-border bg-card overflow-hidden divide-y divide-border">
          {children}
        </div>
      )}
    </section>
  );
};
